import {
  FORETHOUGHT_CUSTOM_ICON_ID,
  FORETHOUGHT_HELP_BUTTON_ID,
  FORETHOUGHT_PROACTIVE_CHAT_CONTAINER_ID,
  FORETHOUGHT_PROACTIVE_CHAT_GREETING_MESSAGE_ID,
  FORETHOUGHT_PROACTIVE_CHAT_INTENTS_CONTAINER_ID,
} from 'embed/constants';

const horizontalShadowWidthForHelpButton = 48;
const verticalShadowWidthForHelpButton = 36;
const horizontalShadowWidthForProactiveChat = 48;
const verticalShadowWidthForProactiveChat = 28;

export const getClosedWidgetSize = () => {
  const helpButton = document.getElementById(FORETHOUGHT_HELP_BUTTON_ID);
  const customIcon = document.getElementById(
    FORETHOUGHT_CUSTOM_ICON_ID,
  ) as HTMLImageElement | null;
  const proactiveChat = document.getElementById(
    FORETHOUGHT_PROACTIVE_CHAT_CONTAINER_ID,
  );
  const greetingMessage = document.getElementById(
    FORETHOUGHT_PROACTIVE_CHAT_GREETING_MESSAGE_ID,
  );
  const intents = document.getElementById(
    FORETHOUGHT_PROACTIVE_CHAT_INTENTS_CONTAINER_ID,
  );

  const helpButtonHeight =
    (customIcon ? customIcon?.height : helpButton?.clientHeight) || 60;
  const helpButtonWidth =
    (customIcon ? customIcon?.width : helpButton?.clientWidth) || 60;

  const proactiveChatHeight = proactiveChat?.clientHeight || 0;
  const proactiveChatWidth = proactiveChat?.clientWidth || 0;

  const greetingMessageWidth = greetingMessage?.clientWidth || 0;
  const intentsWidth = intents?.clientWidth || 0;

  // The most important bit:
  const iframeHeightWithoutShadow = helpButtonHeight + proactiveChatHeight;
  const iframeWidthWithoutShadow = Math.max(
    helpButtonWidth,
    greetingMessageWidth,
    intentsWidth,
  );

  const horizontalShadowWidth = proactiveChatWidth
    ? horizontalShadowWidthForProactiveChat
    : horizontalShadowWidthForHelpButton;
  const verticalShadowWidth = proactiveChatHeight
    ? verticalShadowWidthForProactiveChat
    : verticalShadowWidthForHelpButton;

  // We have to use 0 as the default values when the widget is hidden,
  // because some other code treats 0 size in a special way:
  return {
    height: iframeHeightWithoutShadow
      ? iframeHeightWithoutShadow + verticalShadowWidth
      : 0,

    width: iframeWidthWithoutShadow
      ? iframeWidthWithoutShadow + horizontalShadowWidth
      : 0,
  };
};
